export const FRONT_LEGAL_NAME = 'FrontApp, Inc.';
export const CUSTOMER_COUNT = '9,300+';
export const TRIAL_CTA_TEXT = 'Try for Free';
export const DEMO_CTA_TEXT = 'Request a Demo';
